/* Country options and national-number parsing shared by both Becoming forms. */
(() => {
  window.BecomingPhoneInput = {
    initialize(form) {
      const field = form.querySelector('[data-becoming-phone]');
      const library = window.libphonenumber;
      if (!field || !library) return null;
      if (field.phoneController) return field.phoneController;
      const country = field.querySelector('[data-phone-country]');
      const input = field.querySelector('[data-phone-number]');
      const updateDisplay = () => {
        const code = country.value;
        field.querySelector('[data-phone-flag]').textContent = String.fromCodePoint(...[...code].map((letter) => 127397 + letter.charCodeAt(0)));
        field.querySelector('[data-phone-country-short]').textContent = code;
        field.querySelector('[data-phone-dial-code]').textContent = `+${library.getCountryCallingCode(code)}`;
      };
      const names = new Intl.DisplayNames([document.documentElement.lang || 'en'], { type: 'region' });
      const countries = library.getCountries().map((code) => ({ code, name: names.of(code) || code }));
      countries.sort((a, b) => a.name.localeCompare(b.name));
      country.replaceChildren(...countries.map(({ code, name }) => {
        const option = document.createElement('option');
        option.value = code;
        option.textContent = `${name} (+${library.getCountryCallingCode(code)})`;
        option.defaultSelected = code === 'US';
        return option;
      }));
      country.value = 'US';
      const parse = () => {
        try {
          return library.parsePhoneNumberFromString(input.value.trim(), { defaultCountry: country.value, extract: false });
        } catch { return undefined; }
      };
      const syncInternationalCountry = () => {
        if (!input.value.trim().startsWith('+')) return;
        const number = parse();
        if (number?.country) country.value = number.country;
        else if (number) {
          // Shared calling codes may not identify a territory until more digits arrive.
          const possible = number.getPossibleCountries();
          if (possible.length && !possible.includes(country.value)) country.value = possible[0];
        }
        updateDisplay();
      };
      syncInternationalCountry();
      // Render an existing Shopify international number as a national number.
      const initial = parse();
      if (initial?.isPossible() && initial.getPossibleCountries().includes(country.value) && !initial.ext) input.value = initial.nationalNumber;
      input.addEventListener('input', syncInternationalCountry);
      country.addEventListener('change', updateDisplay);
      form.addEventListener('reset', () => queueMicrotask(updateDisplay));
      updateDisplay();
      field.phoneController = {
        getNumber() {
          const number = parse();
          return number?.isPossible() && !number.ext ? number.number : '';
        },
      };
      return field.phoneController;
    },
  };
})();
